module.exports = __webpack_public_path__ + "media/images/img_service_5-ef7cbf1547d4f03bcc2e832436acc2dd.jpg";